import axios from 'axios'

export default {
  async all(resumo = false) {
    const response = await axios.get('odometer', { params: { resumo } })
    return response
  },

  async dashboard({ startDate, endDate, userId }) {
    const response = await axios.get(
      `odometer/dashboard?startDate=${startDate}&endDate=${endDate}&userId=${userId}`,
    )
    return response
  },

  async delete(id) {
    const response = await axios.delete(`odometer/${id}`)
    return response
  },
}
